/* Publish by EComposer at 2026-11-04 13:16:46*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-frcimcae5fs"]=  window.__ectimmers["ecom-frcimcae5fs"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-frcimcae5fs').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-frcimcae5fs', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-frcimcae5fs', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-acevv7wisv9').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-acevv7wisv9', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-acevv7wisv9', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-2uzxmky71lw').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-2uzxmky71lw', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-2uzxmky71lw', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-p2auorgroo9').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-p2auorgroo9', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-p2auorgroo9', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-h2un1evexn5').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-h2un1evexn5', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-h2un1evexn5', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-3uxkl7mc2sh').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-3uxkl7mc2sh', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-3uxkl7mc2sh', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qlns3dwb8da').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qlns3dwb8da', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qlns3dwb8da', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-k2wwtj8ziz').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-k2wwtj8ziz', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-k2wwtj8ziz', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-npbl64fp0n').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-npbl64fp0n', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-npbl64fp0n', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-xztvmne3i8').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-xztvmne3i8', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-xztvmne3i8', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-sancjnr7nl').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-sancjnr7nl', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-sancjnr7nl', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-4clbxu0n5j6').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-4clbxu0n5j6', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-4clbxu0n5j6', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ltb8slhhd5').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ltb8slhhd5', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ltb8slhhd5', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-w7j6bq6g6r').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-w7j6bq6g6r', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-w7j6bq6g6r', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-1iry3x5pt4x').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-1iry3x5pt4x', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-1iry3x5pt4x', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-llpzkg1jb49').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-llpzkg1jb49', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-llpzkg1jb49', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-2689pk5k4ua').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-2689pk5k4ua', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-2689pk5k4ua', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-7bxg1j1cgpq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-7bxg1j1cgpq', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-7bxg1j1cgpq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ljtwuv51psr').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ljtwuv51psr', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ljtwuv51psr', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-073op2uelcxd').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-073op2uelcxd', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-073op2uelcxd', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-10b7xx8uhcu').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-10b7xx8uhcu', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-10b7xx8uhcu', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-1avuagkxiok').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-1avuagkxiok', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-1avuagkxiok', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-hz7byv6okto').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-hz7byv6okto', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-hz7byv6okto', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-3w6cfmlm5at').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-3w6cfmlm5at', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-3w6cfmlm5at', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ib1wy71ap3f').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ib1wy71ap3f', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ib1wy71ap3f', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-b1x1y4d0aqp').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-b1x1y4d0aqp', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-b1x1y4d0aqp', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-eayi53spj08').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-eayi53spj08', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-eayi53spj08', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-6vgbbh5n679').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-6vgbbh5n679', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-6vgbbh5n679', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-l6m7gh8guvm').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-l6m7gh8guvm', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-l6m7gh8guvm', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-8ttucvz3e64').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-8ttucvz3e64', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-8ttucvz3e64', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-2rsjhv9febp').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-2rsjhv9febp', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-2rsjhv9febp', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-6rp2npl9mof').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-6rp2npl9mof', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-6rp2npl9mof', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-rfgdif9k0a').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-rfgdif9k0a', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-rfgdif9k0a', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-5zh8gp72l1n').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-5zh8gp72l1n', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-5zh8gp72l1n', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ex125ie6o4d').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ex125ie6o4d', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ex125ie6o4d', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-irp59ifz2q').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-irp59ifz2q', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-irp59ifz2q', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-a5d33oyyf2').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-a5d33oyyf2', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-a5d33oyyf2', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-t6xqynry1gi').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-t6xqynry1gi', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-t6xqynry1gi', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ah2emmsgayq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ah2emmsgayq', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ah2emmsgayq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ou97dc2l7ke').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ou97dc2l7ke', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ou97dc2l7ke', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-v9807nx9c8d').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-v9807nx9c8d', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-v9807nx9c8d', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-47meecqrkjw').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-47meecqrkjw', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-47meecqrkjw', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-wft2x8wxw9"]=  window.__ectimmers["ecom-wft2x8wxw9"] || {};
var $,E,I,j,M,D;let t=this.$el;if(!t)return;let e=this.isLive;const i=($=this.settings.disable_auto_close)!=null?$:!1,n=(E=this.settings.disable_auto_close__tablet)!=null?E:!1,o=(I=this.settings.disable_auto_close__mobile)!=null?I:!1,s=(j=this.settings.scroll_on_mobile)!=null?j:!1,r=(M=this.settings.disable_effect)!=null?M:!1,a=(D=this.settings.close_all)!=null?D:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(T=>T.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function p(T){const F=T.getBoundingClientRect();return F.top>=0&&F.left>=0&&F.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&F.right<=(window.innerWidth||document.documentElement.clientWidth)}function m(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(T){return o&&T<768||n&&T>767&&T<1025||i&&T>1024}function b(T){if(!T)return;const F=T.style.transition;T.style.transition="none",T.style.height="auto";const H=T.scrollHeight;T.style.height="0px",T.offsetHeight,T.style.transition=F,requestAnimationFrame(()=>{const R=r?"auto":e?H+"px":"auto";T.style.height=R})}function y(T){T.classList.remove("ecom-item-active");const F=T.querySelector(":scope > .ecom-accordion__body");F&&(r||(F.style.height=F.scrollHeight+"px",F.offsetHeight),requestAnimationFrame(()=>{F.style.height="0px"}))}function v(T){let F=0;if(T.offsetParent)do F+=T.offsetTop;while(T=T.offsetParent);return F}function w(T){const F=Math.max(0,T),H=window.pageYOffset||document.documentElement.scrollTop,R=F-H;if(R===0)return;const K=300;let W=null;function G(se){W||(W=se);const te=Math.min((se-W)/K,1),Y=te<.5?2*te*te:1-Math.pow(-2*te+2,2)/2;window.scrollTo(0,H+R*Y),te<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function S(T){w(v(T)-100)}function C(T,F=!1){T.forEach((H,R)=>{const K=H.parentNode,W=K.querySelector(":scope > .ecom-accordion__body");!r&&W&&W.classList.add("ecom-effect-accodion");const G=K.classList.contains("ecom-item-active");W&&!a&&(F&&R===0||G)&&requestAnimationFrame(()=>{W.style.height=W.scrollHeight+"px"}),H.onclick=function(se){var ue,_e;if(se.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const te=m(),Y=this.parentNode,pe=Y.parentNode,de=pe.querySelectorAll(":scope > .ecom-accordion__item"),me=Array.from(de).map(we=>we.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),J=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const V=this.classList.contains("ecom-item-active"),X=_(te);if(V)X?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(de.forEach(y),me.forEach(we=>we.classList.remove("ecom-item-active")));else{X||(de.forEach(y),me.forEach(Ae=>Ae.classList.remove("ecom-item-active"))),H.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let we=Y.closest(".ecom-accordion__body");for(;we;)we.style.height="auto",we=(_e=(ue=we.parentElement)==null?void 0:ue.closest)==null?void 0:_e.call(ue,".ecom-accordion__body");!r&&J&&J.classList.add("ecom-effect-accodion"),b(J)}window.dispatchEvent(new window.Event("renderScroll"));const Q=this,ge=s||te>1024;function ee(){window.dispatchEvent(new window.Event("renderScroll")),ge&&!p(Q)&&S(Q)}if(ge&&!r){let we;const Ae=function(Ee){Ee.propertyName==="height"&&(clearTimeout(we),we=setTimeout(()=>{pe.removeEventListener("transitionend",Ae),ee()},50))};pe.addEventListener("transitionend",Ae),setTimeout(()=>{pe.removeEventListener("transitionend",Ae),ee()},600)}else requestAnimationFrame(()=>{setTimeout(ee,100)})}})}C(d,!0),a||requestAnimationFrame(()=>{const T=t.querySelector(".ecom-item-group-init");T&&T.classList.remove("ecom-item-group-init")});function x(){const T=window.location.hash;if(T){const F=t.querySelector(`[data-target="${T}"]`);if(F){F.click(),F.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const K=F.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(K)}}}requestAnimationFrame(()=>{setTimeout(x,100)}),window.addEventListener("resize",()=>C(d)),window.addEventListener("hashchange",x,!1)

                    });
                    
                        document.querySelectorAll('.ecom-wft2x8wxw9').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-wft2x8wxw9', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-wft2x8wxw9', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7idphf9suhy"]=  window.__ectimmers["ecom-7idphf9suhy"] || {};
if(!this.settings||!this.$el)return;const t=this.$el,e=this.isLive,i=this.settings.loop,n=this.settings.autoplay,o=this.settings.lazyload||!1,s=this.settings.player_controls||!1,r=this.settings.pause_on_hover||!1,a=this.settings.click_to_play_pause,l=this.settings.play_on_lightbox||!1,c=1;let d=t.querySelector(".ecom-video_overlay-icon");const p=t.querySelector(".ecom-video-poster");let m;m=d&&d.querySelector(".ecom-video-icon-play");const _=t.querySelector(".ecom-element_video-iframe");o&&setTimeout(function(){b(_)},500);function b(I){let j={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(w,j).observe(I)}function y(I,j){let M={handleMouseenter:D,handleMouseleave:T,handleEnded:F};function D(){I.readyState>=c&&I.pause()}function T(){I.readyState>=c&&I.play()}function F(){v(I,M)}if(r){I.addEventListener("mouseenter",D),I.addEventListener("mouseleave",T);let H=t.querySelector(".ecom-video_link-extra");H&&H.href&&(H.addEventListener("mouseenter",D),H.addEventListener("mouseleave",T)),j||I.addEventListener("ended",F)}}function v(I,j){if(j){const{handleMouseenter:M,handleMouseleave:D,handleEnded:T}=j;let F=t.querySelector(".ecom-video_link-extra");I.removeEventListener("mouseenter",M),I.removeEventListener("mouseleave",D),I.removeEventListener("ended",T),F&&F.href&&(F.removeEventListener("mouseenter",M),F.removeEventListener("mouseleave",D))}}function w(I,j){I.forEach(function(M){if(M.isIntersecting){const D=M.target.querySelector("video source"),T=M.target.querySelector("video"),F=M.target.querySelector("iframe");if(T&&D&&(D.src=D.dataset.source,T.load(),T.addEventListener("loadeddata",function(){n&&T.play()})),F){let H=F.dataset.srcVideo;F.setAttribute("src",H)}j.unobserve(M.target)}})}let S=t.querySelector(".ecom_video"),C=t.querySelector(".ecom_iframe");a&&S&&S.addEventListener("click",()=>{S.readyState>=c&&(S.paused?S.play():S.pause())}),n&&(d&&d.classList.remove("ecom-overlay"),m&&(m.style.display="none"),p&&(p.style.display="none")),S&&!i&&S.addEventListener("ended",function(){p&&(p.style.display="block"),d&&d.classList.add("ecom-overlay"),m&&(m.style.display="block")}),d&&d.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&S)p&&(p.style.display="none"),S.autoplay=!0,S.play(),d.classList.remove("ecom-overlay"),m.style.display="none";else if(C){let I=C.getAttribute("src");I.includes("autoplay=0")?I=I.replace("autoplay=0","autoplay=1"):I=I+"&autoplay=1",C.setAttribute("src",I),l?setTimeout(()=>{I=I.replace("autoplay=1","autoplay=0"),C.setAttribute("src",I)},100):(p&&(p.style.display="none"),d.classList.remove("ecom-overlay"),m.style.display="none")}}),S&&(e&&!p&&y(S,i),p&&p.addEventListener("click",function(){p.style.display="none",S.play(),e&&y(S,i)}),r||S.addEventListener("pause",function(){p&&(p.style.display="block"),d&&d.classList.add("ecom-overlay"),m&&(m.style.display="block")}),!s&&d&&S.addEventListener("click",function(){S.pause()})),t.querySelectorAll("[data-ec-tracking-id]").forEach(function(I){I.dataset.ecTrackingId&&I.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:I.id,tracking_id:I.dataset.ecTrackingId})},{once:!0})});const x=t.querySelector("[ecom-modal]"),$=function(I){if(window.EComModal)return I();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&I()});return}let j=0;const M= window.__ectimmers["ecom-7idphf9suhy"]["e8r22rhzv"] = setInterval(function(){window.EComModal?(clearInterval(M),I()):++j>=300&&clearInterval(M)},50)},E=this.id;x&&this.settings.image_overlay&&l&&$(function(){const I=x.dataset.width,j=x.dataset.height;var M=E;new window.EComModal(x,{cssClass:[M,"ecom-core","ecom-core-simulator"],onOpen:function(){var D=document.querySelector(".ecom-modal."+M);if(D){const T=D.querySelector(".ecom-modal-box__content");T.classList.add("ecom-element_video-iframe");const F={width:I,height:j};Object.assign(T.style,F)}},onClose:function(){var D=document.querySelector(".ecom-modal."+M);if(D){const T=D.querySelector(".ecom-element_video-iframe iframe");T&&(T.src="")}}})})

                    });
                    
                        document.querySelectorAll('.ecom-7idphf9suhy').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-7idphf9suhy', settings: {"autoplay":false,"player_controls":true,"source":"youtube"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-7idphf9suhy', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0c6wy1f2qtb"]=  window.__ectimmers["ecom-0c6wy1f2qtb"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-0c6wy1f2qtb"]["e21lru4ft"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-0c6wy1f2qtb').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-0c6wy1f2qtb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-0c6wy1f2qtb', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-y0hv3m5ti7p').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-y0hv3m5ti7p', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-y0hv3m5ti7p', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ywisriwt5zi').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ywisriwt5zi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ywisriwt5zi', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-u7uygyxm3fe').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-u7uygyxm3fe', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-u7uygyxm3fe', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-3avzhxvit9o').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-3avzhxvit9o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-3avzhxvit9o', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-dm0e802w0v7').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-dm0e802w0v7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-dm0e802w0v7', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-47xucanyzmm').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-47xucanyzmm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-47xucanyzmm', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qx5skc1nlnk').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qx5skc1nlnk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qx5skc1nlnk', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-355ul23vv3v').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-355ul23vv3v', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-355ul23vv3v', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-idlar9nek7l').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-idlar9nek7l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-idlar9nek7l', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-xs682swonop').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-xs682swonop', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-xs682swonop', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-y0a8upzpa8').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-y0a8upzpa8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-y0a8upzpa8', e);
                            }
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}